const $ = jQuery.noConflict();
import Global from '../shared/global';

'use strict';

const formPopup = {
	$registerForm: $('.register-form'),
	$registerFormInner: $('.js-register-form-inner'),
	$registerFormClose: $('.js-register-form-close'),
	$registerFormTrigger: $('.js-trigger-register-popup'),

	init: function() {
		if ($('.js-register-form-inner').length) {
			this.bindEvents();
		}
	},

	bindEvents: function() {
		const $ignoreClose = $('.js-trigger-register-popup, .js-register-form-inner');

		Global.clickOutsideContainer(Global.$domBody, $ignoreClose, formPopup.$registerFormClose, formPopup.removePopup);
		formPopup.$registerFormTrigger.on('click', this.showPopup);
		formPopup.$registerFormClose.on('click', this.removePopup);
	},

	showPopup: function() {
		formPopup.$registerForm.addClass('active');
		$(document.body).addClass('overflow-active');
	},

	removePopup: function() {
		formPopup.$registerForm.removeClass('active');
		$(document.body).removeClass('overflow-active');
	},
};

export default formPopup;
